export const HOST = "https://asset.metahos.com";
